module.exports = __webpack_public_path__ + "static/media/MissionImage.1d7c320c.png";